import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class extends Component {
  render() {
    //let backgroundPosition:'center';
    let backgroundPosition:'top'; //Kathryn hack
    if(this.props.forceToTop){
      backgroundPosition = 'top'
    }
    if(this.props.forceToBottom){
      backgroundPosition = 'bottom'
    }
    let image = this.props.image;
    if(this.props.mobileOptimize && window.outerWidth < 800){
      image = this.props.image.replace('.jpg','-mobile.jpg');
    }
    return(
      <div className="background-image-fill"
        style={{
          height:"100vh",
          width:"100vw",
          marginBottom:"-20%",
          backgroundImage:"url("+image+")",
          backgroundPosition:backgroundPosition
        }}>
        <div className="full-height full-width horizontal-overlay-gradient" style={{display:'flex', alignItems:'center'}}>
          <div className="medium-padding">
            <h4 className="white tiny-top-margin">{this.props.subtitle}</h4>
            <h1 className="white">{this.props.title}</h1>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collectionHero/index.js